import React from 'react';
import { Dumbbell, BookOpen, Music, BarChart2, FileText, Apple } from 'lucide-react';

const highlights = [
  {
    icon: Dumbbell,
    title: 'Eksklusive øvelser',
    description: 'Hundrevis av treningsøvelser filmet av sertifiserte trenere for alle nivåer.',
  },
  {
    icon: Apple,
    title: 'Næringsrike oppskrifter',
    description: 'Sunne og smakfulle matoppskrifter som støtter treningsresultatene dine.',
  },
  {
    icon: BarChart2,
    title: 'Treningssporing',
    description: 'Hold oversikt over fremgangen din med intuitive sporingsverktøy i appen.',
  },
  {
    icon: Music,
    title: 'Motiverende musikk',
    description: 'Spesialkomponerte treningsplaylister som gir deg energien til å pushe grensene.',
  },
  {
    icon: BookOpen,
    title: 'E-bøker om trening',
    description: 'Dyptgående guider om styrketrening, utholdenhet, kosthold og mental helse.',
  },
  {
    icon: FileText,
    title: 'Ekspertartikler',
    description: 'Faglige råd og instruksjonsartikler fra trenere, ernæringsfysiologer og coacher.',
  },
];

const Features = () => {
  return (
    <section id="oppdag" className="py-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <span className="text-primary-light text-sm font-semibold uppercase tracking-widest">Oppdag</span>
            <h2 className="mt-3 text-4xl lg:text-5xl font-black text-white font-heading leading-tight">
              Ta kontroll over{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
                treningsreisen din
              </span>
            </h2>
          </div>
          <div>
            <p className="text-lg text-slate-400 leading-relaxed">
              Workout ON samler eksklusive treningsvideoer, sunne kostholdsplaner, motiverende musikk,
              e-bøker og sporingsverktøy på én plattform. Enten du sikter mot bedre utholdenhet,
              styrke eller fleksibilitet – her finner du alt du trenger for å holde deg i form.
            </p>
            <div className="mt-6 flex items-center space-x-4">
              <img
                src="/images/beach_generic.png"
                alt="Workout ON på mobil"
                className="w-24 h-24 rounded-2xl object-cover shadow-lg ring-1 ring-primary/20"
              />
              <div>
                <p className="text-white font-semibold">Tilgjengelig på alle enheter</p>
                <p className="text-slate-400 text-sm mt-1">Mobil, nettbrett og PC</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="group bg-card-dark border border-border-dark rounded-2xl p-7 hover:border-primary/40 hover:bg-gradient-card transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-primary/10 border border-primary/20 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary/20 transition-colors">
                <item.icon className="w-7 h-7 text-primary-light" />
              </div>
              <h3 className="text-lg font-bold text-white mb-3 font-heading">{item.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
